import { computePosition, autoUpdate, offset, flip } from '@floating-ui/dom';

export default (content) => {
    return (inputOptions) => {
        const oldContent = content(inputOptions);

        return {
            ...oldContent,

            getTimeFromDate(dateTime) {
                return oldContent.getTimeFromDate(String(dateTime));
            },

            initPositioningSystem() {
                this.$refs.popover.style.position = 'fixed';
                this.$refs.popover.style.visibility = 'hidden';
                this.$refs.popover.style.width = `${this.$root.offsetWidth}px`;
                this.$refs.popover.style.bottom = 'auto';
                this.$refs.popover.style.right = 'auto';

                this.$watch('popover', (state) => {
                    if (!state && this.cleanupPosition) {
                        this.cleanupPosition();
                        this.cleanupPosition = null;
                    }

                    if (state) {
                        this.$refs.popover.style.visibility = 'hidden';
                    }

                    if (state && !this.cleanupPosition) {
                        this.refreshPopover();
                    }
                });

                this.$watch('filteredTimes', () => {
                    this.$nextTick(() => this.adjustPopoverHeight());
                });
            },

            updatePosition() {
                computePosition(this.$root, this.$refs.popover, {
                    placement: 'bottom',
                    middleware: [offset(4), flip()],
                    strategy: 'fixed',
                }).then(({ x, y }) => {
                    Object.assign(this.$refs.popover.style, {
                        position: 'fixed',
                        left: `${x}px`,
                        top: `${y}px`,
                        width: `${this.$root.offsetWidth}px`,
                        bottom: 'auto',
                        right: 'auto',
                    });

                    setTimeout(() => {
                        this.$refs.popover.style.visibility = 'visible';
                    }, 100);
                });
            },

            refreshPopover() {
                this.$nextTick(() => {
                    this._waitUntilStable(() => {
                        this.syncPopoverPosition();
                    });
                });
            },

            _waitUntilStable(callback) {
                let lastRect = this.$root.getBoundingClientRect();

                const check = () => {
                    const rect = this.$root.getBoundingClientRect();

                    if (rect.left === lastRect.left && rect.top === lastRect.top) {
                        callback();
                    } else {
                        lastRect = rect;
                        requestAnimationFrame(check);
                    }
                };

                requestAnimationFrame(check);
            },

            syncPopoverPosition() {
                this.cleanupPosition = autoUpdate(
                    this.$root,
                    this.$refs.popover,
                    () => this.updatePosition(),
                    { ancestorResize: true, ancestorScroll: true, elementResize: true },
                );

                this.$nextTick(() => this.adjustPopoverHeight());

                if (!this._anchorResizeObserver) {
                    this._anchorResizeObserver = new ResizeObserver(() => {
                        if (this.popover) {
                            this.updatePosition();
                        }
                    });

                    let ancestor = this.$root.parentElement;

                    while (ancestor && ancestor !== document.body) {
                        const overflow = window.getComputedStyle(ancestor).overflow;

                        if (overflow === 'auto' || overflow === 'scroll' || overflow === 'hidden') {
                            break;
                        }

                        ancestor = ancestor.parentElement;
                    }

                    if (ancestor && ancestor !== document.body) {
                        this._anchorResizeObserver.observe(ancestor);
                    } else {
                        this._anchorResizeObserver.observe(this.$root.parentElement);
                    }

                    const origCleanup = this.cleanupPosition;

                    this.cleanupPosition = () => {
                        origCleanup();
                        this._anchorResizeObserver?.disconnect();
                        this._anchorResizeObserver = null;
                    };
                }
            },

            adjustPopoverHeight() {
                const list = this.$refs.popover?.querySelector('ul');
                if (!list) return;

                const itemCount = this.filteredTimes?.length || 0;
                const itemHeight = 44;
                const padding = 16;
                const minItems = window.innerWidth >= 640 ? 2 : 3;
                const maxItems = window.innerWidth >= 640 ? 5 : 8;
                const height = itemCount >= minItems 
                    ? Math.min(itemCount, maxItems) * itemHeight + padding 
                    : minItems * itemHeight + padding;

                list.style.height = `${height}px`;
                list.style.maxHeight = '';
            },
        };
    };
};
